import { useState, useEffect } from "react";
import GroupApi from "../../../api/GroupApi";
import SlotApi from "../../../api/SlotApi";

const enrichGroupsWithKeywords = async (groups) => {
    const slots = await SlotApi.getSlots(1, 500, "", "", "ST001");
    if (!Array.isArray(slots)) return groups;

    return groups.map((group) => ({
        ...group,
        keywords: slots
            .filter((slot) => String(slot.slotGroupId) === String(group.groupId))
            .map((slot) => slot.slotKeyword)
            .filter(Boolean),
    }));
};

const MyGroup = () => {
    const [groupNmInput, setGroupNmInput] = useState("");
    const [groups, setGroups] = useState([]);

    const handleNewGroupNmInputChg = (e) => setGroupNmInput(e.target.value);

    const handleGroupNmChg = (e, group) => {
        group.groupNm = e.target.value;
        setGroups([...groups]);
    };

    const handleGroupAddBtn = async () => {
        const name = groupNmInput.trim();
        if (!name) return alert("그룹 이름을 입력해주세요.");

        const group = { groupNm: name };
        const res = await GroupApi.createGroup(group);
        if (!res) return alert("그룹 생성을 실패했습니다.");
        group.groupId = res.groupId;
        group.keywords = [];
        setGroups([group, ...groups]);
        setGroupNmInput("");
    };

    const handleGroupAddKeyDown = (e) => {
        if (e.key === "Enter") handleGroupAddBtn();
    };

    const handleGroupEditBtn = (group) => {
        group.isEdit = true;
        setGroups([...groups]);
    };

    const handleGroupSaveBtn = async (group) => {
        const res = await GroupApi.updateGroup(group.groupId, group);
        if (!res) return alert("그룹 변경을 실패했습니다.");
        group.isEdit = false;
        setGroups([...groups]);
    };

    const handleGroupDelBtn = async (group) => {
        const res = await GroupApi.deleteGroup(group.groupId);
        if (!res) return;
        setGroups(groups.filter((g) => g.groupId !== group.groupId));
    };

    const loadGroups = async () => {
        const data = await GroupApi.getGroups();
        if (!data) return;
        const enriched = await enrichGroupsWithKeywords(data);
        setGroups(enriched);
    };

    useEffect(() => {
        loadGroups();
    }, []);

    return (
        <section className="mypage-container">
            <section className="group-manage">
                <div className="group-manage-head">
                    <input
                        type="text"
                        placeholder="그룹 이름"
                        value={groupNmInput}
                        onChange={handleNewGroupNmInputChg}
                        onKeyDown={handleGroupAddKeyDown}
                    />
                    <button type="button" onClick={handleGroupAddBtn}>
                        추가
                    </button>
                </div>

                <div className="group-manage-list">
                    {groups.map((group) => (
                        <article key={`group_${group.groupId}`} className="group-manage-card">
                            <div className="group-manage-card-head">
                                {group.isEdit ? (
                                    <input
                                        type="text"
                                        value={group.groupNm}
                                        onChange={(e) => handleGroupNmChg(e, group)}
                                        style={{
                                            flex: 1,
                                            minWidth: 0,
                                            margin: 0,
                                            fontSize: 16,
                                            fontWeight: 600,
                                            color: "#444",
                                            border: "1px solid #e1e5eb",
                                            borderRadius: 4,
                                            padding: "4px 8px",
                                        }}
                                    />
                                ) : (
                                    <h3>{group.groupNm}</h3>
                                )}

                                <div className="group-manage-actions">
                                    {group.isEdit ? (
                                        <button
                                            type="button"
                                            className="group-manage-edit"
                                            aria-label="저장"
                                            onClick={() => handleGroupSaveBtn(group)}
                                        >
                                            <i className="icon icon-group-edit"></i>
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            className="group-manage-edit"
                                            aria-label="수정"
                                            onClick={() => handleGroupEditBtn(group)}
                                        >
                                            <i className="icon icon-group-edit"></i>
                                        </button>
                                    )}
                                    <button
                                        type="button"
                                        className="group-manage-delete"
                                        aria-label="삭제"
                                        onClick={() => handleGroupDelBtn(group)}
                                    >
                                        <i className="icon icon-group-delete"></i>
                                    </button>
                                </div>
                            </div>

                            {group.keywords?.length > 0 && (
                                <div className="group-manage-tags">
                                    {group.keywords.map((keyword) => (
                                        <span key={`${group.groupId}_${keyword}`}>{keyword}</span>
                                    ))}
                                </div>
                            )}
                        </article>
                    ))}
                </div>
            </section>
        </section>
    );
};

export default MyGroup;
